import { render, staticRenderFns } from "./MatchForm.vue?vue&type=template&id=541ddd28&scoped=true&"
import script from "./MatchForm.vue?vue&type=script&lang=js&"
export * from "./MatchForm.vue?vue&type=script&lang=js&"
import style0 from "./MatchForm.vue?vue&type=style&index=0&id=541ddd28&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541ddd28",
  null
  
)

export default component.exports